
import rendererCommons from "@/components/UserInterfaces/renderer/mixins/renderer-commons";

export default {
    name: "ComponentRenderer",
    mixins: [
        rendererCommons
    ],
    data() {
        return {
        };
    },
    computed: {
        body() {
            if (this.isFragment) {
                const fragmentList = this.$store.state.components.fragments;
                const { fragment } = this.componentProperties;
                const { interfaceJson } = (fragment && fragmentList[fragment]) || {};

                return interfaceJson.body || [];
            }

            return this.component.body;
        },
        isFragment() {
            return this.componentType === "ctrl-fragment";
        },
        canLoadBody() {
            return !this.isFragment || this.live;
        }
    },
    methods: {
        canLoadSlotBody: (activeSlot, slot) => activeSlot === `${slot.guid}`
    }
};
